import {FC, useEffect, useState} from "react";
import {toAbsoluteUrl} from "../../../../../_kiloit/helpers";
import {Table} from "react-bootstrap";
import clsx from "clsx";
import {DrawModel} from "../../core/_models";
import {useNavigate} from "react-router-dom";
import {drawStatus} from "../../../../constants/general";
import LottieLoader from "../../../../../_kiloit/helpers/components/LottieLoader";
import {gameType} from "../../../../constants/config";
import _ from "lodash";
import {stLabel} from "../../../../constants/game";


type props = {
    draw: DrawModel
}
const GameTable: FC<props> = ({draw}) => {
    const navigate = useNavigate();
    let [countDown, setCountDown] = useState(0);
    const [status, setStatus] = useState("");

    useEffect(() => {
        let timerInv: NodeJS.Timer;
        const st = draw.currentDraw?.status!;
        const cd = draw.currentDraw?.countDown!;
        if (st === drawStatus.drawing) {
            setStatus("MB");
        } else {
            setStatus("");
            let count = cd - 1;
            timerInv = setInterval(() => {
                count--;
                if (count <= 0) {
                    clearInterval(timerInv);
                    setStatus("MB");
                }
                setCountDown(count);
            }, 1000);
        }
        return () => {
            return clearInterval(timerInv);
        }

    }, [draw.currentDraw]);

    const isManual = draw.type === gameType.manual;


    return <div
        className="col-12 col-xl-6 col-md-12 col-lg-6 p-0">
        <div
            className="game-table">
            <div onClick={() => navigate(`xocdia/${draw.tableId}/${draw.type}`)} className="cursor-pointer">
                <div className="game-table-header">
                    <div className="game-name d-flex align-items-center">
                        <span>Xóc Đĩa {draw.tableId}</span>
                        {isManual && <div className="mt-6">
                            <LottieLoader
                                loop={true}
                                width={60}
                                height={60}
                                src={require('../../../../../_kiloit/assets/lottie/Lives_Animation.json')}/>
                        </div>}
                    </div>
                    {/*<div className="d-flex game-result">*/}
                    {/*    <div className="cl bg_l">L</div>*/}
                    {/*    <div className="number-result">110</div>*/}
                    {/*    <div className="cl bg_c">C</div>*/}
                    {/*    <div className="number-result">112</div>*/}
                    {/*</div>*/}

                    <div className="d-flex game-result text-white">
                        <div>{draw?.drawLabel}</div>
                    </div>

                </div>
                <div className="row game-table-body ">
                    <div className="col-4 pe-2 position-relative">
                        <img className="img-game" src={toAbsoluteUrl("/media/game/101_M.jpg")} alt=""/>
                        {!isManual && <div className={clsx("sd-tb-rec-border", status)}>
                            {countDown <= 0 ? status : countDown}
                        </div>}
                    </div>
                    <div className="col-8 ps-0">
                        <Table className="lobby-his">
                            <tbody>
                            {draw.statistic?.range.map((e, i) => {
                                return <tr key={i}>
                                    {e.map((p, j) => {
                                        return <td key={j} className="text-danger border">
                                            <div
                                                className={clsx("d-flex justify-content-center align-items-center  rounded-circle h-100", `result-dice-${_.toLower(p)}`)}>
                                                <div
                                                    className={clsx("d-flex justify-content-center align-items-center text-white", {
                                                        "text-white": p === ""
                                                    })}>{stLabel[p]}</div>
                                            </div>
                                        </td>
                                    })}
                                </tr>
                            })}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default GameTable;